import type { KeyboardEvent } from 'react';

/**
 * Whether a key belongs to an IME's composition, whose Enter confirms a word and sends nothing. Safari ends the
 * composition before the Enter's keydown, which it marks with key code 229 instead.
 */
export const isComposing = (event: KeyboardEvent): boolean => event.nativeEvent.isComposing || event.keyCode === 229;
